import { PlayerService } from '@modules/player/player-service';
import Errors from '@shared/error/errors';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';

export default {
    namespaced: true,

    state: {
        loading: false,
        listTeamPlayer: []
    },

    getters: {
        listTeamPlayer: (state) => state.listTeamPlayer,
        loading: (state) => !!state.loading,
    },

    mutations: {
        RESET(state) {
            state.loading = false;
            state.listTeamPlayer = [];
        },

        LIST_STARTED(state) {
            state.loading = true;
        },

        LIST_SUCCESS(state, payload) {
            state.listTeamPlayer = payload;
            state.loading = false;
        },

        LIST_ERROR(state) {
            state.listTeamPlayer = [];
            state.loading = false;
        },

        UPDATE_STARTED(state) {
            state.loading = true;
        },

        UPDATE_SUCCESS(state) {
            state.loading = false;
        },

        UPDATE_ERROR(state) {
            state.loading = false;
        },
    },

    actions: {
        doReset({ commit }) {
            commit('RESET');
        },

        async doGetTeams({ commit }, { id, subpropertyId }) {
            try {
                commit('LIST_STARTED');
                const list = await PlayerService.getTeams(id, subpropertyId);
                commit('LIST_SUCCESS',list);
            } catch (error) {
                Errors.handle(error);
                commit('LIST_ERROR');
            }
        },

        async doUpdateTeams({ commit }, { id, subpropertyId, teams }) {
            try {
                commit('UPDATE_STARTED');
                await PlayerService.updateTeams(id, subpropertyId, teams);

                commit('UPDATE_SUCCESS');
                Message.success(i18n('entities.player.update.success'));
            } catch (error) {
                Errors.handle(error);
                commit('UPDATE_ERROR');
            }
        },
    },
};